export enum Status {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  TRANSFER_ERROR = 'TRANSFER_ERROR',
  ERROR = 'ERROR',
}
